module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-13-5e3f91eed6a442b75084fe89e323a85d.jpg";